module.exports = "../dist/img/product-detail-2-27.6893.jpg";